import React, { useEffect, useRef, useState } from "react";
import Image from "../../../elements/image";
import classNames from "classnames";
const PhotoWallImage = props => {
  const  { index, item } = props;
  const rootEl = useRef();
  const [active, setActive] = useState(false)
  // const isMobile = mobileIs();
  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    }
  }, []);
  const onScroll = () => {
    if(rootEl.current){
      let top = rootEl.current.getBoundingClientRect().top;
      let height = rootEl.current.getBoundingClientRect().height;
      let width = rootEl.current.getBoundingClientRect().width;
      let offsetX = rootEl.current.getBoundingClientRect().x;
      let winHeight = window.innerHeight;
      let winWidth = window.innerWidth;
      if(index == 0){
        if( top < winHeight - height/2 && offsetX > -(width/2)){
          setActive(true)
        }else{
          setActive(false)
        }
        

      } else if (index == 1){
        if( top < winHeight - height/2 && offsetX < (winWidth-width/2)){
          setActive(true)
        }else{
          setActive(false)
        }
      }else{
        if( top < ( winHeight - height/2) && top>0){
          setActive(true)
        }
        if( top > winHeight || top < 0){
          setActive(false)
        }
      }
    }
  }
  const itemName = `PhotoWall-item PhotoWall-item-${index}`
  return (
    <div className={classNames(itemName, active ? 'active' : null)} ref={rootEl}>
      <Image className="img" { ...item.fields.image.value} />
    </div>
  )
};
export default PhotoWallImage;
